import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
function PlaceholderComponent({ node, updateAttributes, extension }) {
  const { label, value, id } = node.attrs;
  const readOnly = extension.options.readOnly;

  return (
    <NodeViewWrapper
      id={id} // ✅ CRITICAL
      data-placeholder-id={id}
      data-field-id={id}
      className="inline-block align-middle"
    >
      <input
        value={value || ''}
        placeholder={label || 'Enter value'}
        disabled={readOnly} // 🔥 IMPORTANT
        onChange={(e) => {
          if (readOnly) return;
          updateAttributes({ value: e.target.value });
        }}
        className="
  min-w-[160px]
  px-3 py-1.5
  text-sm

  bg-white
  border border-slate-200
  rounded-lg

  shadow-sm

  transition-all duration-200

  hover:border-slate-300 hover:shadow

  focus:outline-none
  focus:ring-2 focus:ring-[#375AE7]/20
  focus:border-[#375AE7]
"
      />
    </NodeViewWrapper>
  );
}

export const Placeholder = Node.create({
  name: 'placeholder',

  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: { default: null },
      key: { default: '' },
      label: { default: 'Enter value' },
      value: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'placeholder' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['placeholder', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(PlaceholderComponent);
  },
});
